// src/components/Team/Team.jsx
import React, { useContext, useMemo, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";

import styles from "./Team.module.scss";
import NavContext from "../../context/NavContext";
import { useUserInviteContext } from "../../context/UserInviteContext";

import TutorialInvite from "./InvitUser/TutorialInvite";
import UserArrayPreview from "./userCard/UserArrayPreview";
import { useTeamData } from "./userCard/UseTeamData";

import TeamDetails from "./userCard/TeamDetails";
import RightDrawer from "components/Rightpanel/RightDrawer";

export default function Team() {
  const { ownerId, userAuth, ownerProfile } = useContext(NavContext);
  const { inviteId } = useUserInviteContext();
  const { t } = useTranslation();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [inviteOpen, setInviteOpen] = useState(false); // ✅ nouveau

  const team = useTeamData({ ownerId, inviteId, userAuth });

  const openDrawer = useCallback(() => {
    setInviteOpen(false);
    setDrawerOpen(true);
  }, []);

  const openDrawerInvite = useCallback(() => {
    setInviteOpen(true);      // ✅ on force l’ouverture du formulaire
    setDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setDrawerOpen(false);
    setInviteOpen(false);     // ✅ reset
  }, []);

  const previewUser = useMemo(() => {
    const list = Array.isArray(team?.inviteUser) ? team.inviteUser : [];
    if (list.length === 0) return null;

    const ownerUserId = ownerProfile?.ID;
    if (ownerUserId) {
      const match = list.find((u) => String(u.ID) === String(ownerUserId));
      if (match) return match;
    }
    return list[0];
  }, [team?.inviteUser, ownerProfile?.ID]);

  const usersCount = Array.isArray(team?.inviteUser) ? team.inviteUser.length : 0;
  const inviteCount = Array.isArray(team?.inviteWaiting) ? team.inviteWaiting.length : 0;

  return (
    <>
      <motion.main
        className={styles.teamRoot}
        variants={animatePage}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {usersCount === 0 && (
          // ✅ Ici : on ouvre directement le formulaire
          <TutorialInvite onToggle={openDrawerInvite} />
        )}

        {previewUser ? (
          <UserArrayPreview
            user={previewUser}
            roleLabel={team.displayRoleByUser(previewUser.ID)}
            inviteCount={inviteCount}
            usersCount={usersCount}
            onToggle={openDrawer}
            onInviteClick={openDrawerInvite} // ✅ si tu veux que "inviter" ouvre aussi le form
          />
        ) : null}
      </motion.main>

      <RightDrawer
        isOpen={drawerOpen}
        onClose={closeDrawer}
        title={`Mon équipe (${usersCount})`}
        width="720px"
      >
        <TeamDetails
          ownerId={ownerId}
          inviteId={inviteId}
          userAuth={userAuth}
          defaultInviteOpen={inviteOpen} // ✅ prop
        />
      </RightDrawer>
    </>
  );
}